import styled from "styled-components";
import { Grid } from "@material-ui/core";
import theme from "~/styles/theme";
import { Button } from "~/components/elements";

export const ContentHolder = styled(Grid)`
  padding: 0 16px 32px 16px;
  text-align: left;
  margin-top: 40px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    min-height: calc(100vh - 429px);
    text-align: left;
    margin-top: 64px;
    padding: 0 16px 64px 16px;

    /* max-width: 1024px; */
  }
`;
export const NavbarHolder = styled.div`
  width: 100%;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 276px;
  }
`;


export const AccountMenu = styled.ul`
  width: 100%;
  border: 2px solid ${theme.palette.brand.primary.key};
  overflow: hidden;
  text-align: left;
  border-radius: 16px;

  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 272px;
  }
`;

export const MenuItem = styled.li`
  border-bottom: 1px solid ${theme.palette.neutral.primary.key};
  padding: 23px 24px;
  background: ${(props) =>
    props.selected
      ? theme.palette.brand.primary.key
      : "#F5F5F5"};
  &:last-child {
    border: none;
  }
  cursor: pointer;
  p {
    font-weight: ${(props) => (props.selected ? 500 : 400)};
    color: ${(props) =>
      props.selected
        ? theme.palette.neutral.primary.light
        : theme.palette.neutral.primary.key};
  }

  &.hide {
    display: none;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: flex;
    }
  }

  &.show {
    display: block;

    @media (min-width: ${theme.breakpoints.values.md}px) {
      display: flex;
    }
  }

  #chalengeButton {
    transform: rotate(90deg);

    @media (min-width: ${theme.breakpoints.values.md}px) {
      transform: none;
    }
  }
`;

export const CardsHolder = styled.div`
  width: 100%;
  @media (min-width: ${theme.breakpoints.values.md}px) {
    width: 702px;
  }

  .title {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    span {
      font-family: ${theme.typography.fontFamilyRegular};
      // color: ${theme.palette.neutral.primary.key};
    }
  }
`;

export const TitleHolder = styled.div`
  width: 100%;
  padding: 0 16px;

  h1 {
    text-align: left;
  }
`;

export const NameHolder = styled.div`
  margin-bottom: 16px;
  h5 {
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  svg {
    width: 38px;
    height: 28px;
    margin-right: 8px;
  }
`;

export const BlueContainer = styled.div`
  margin-top: 48px;
  padding: 24px;
  font-size: 24px;
  font-weight: bold;
  color: #FFFF;
  background-color: ${theme.palette.brand.primary.key};
  border-radius: 16px;
  text-align: center;

  .yellow-text {
    color: #FCC800;
  }

`

export const CoupomTitle = styled.div`
  h1 {
    font-size: 24px;
    font-weight: bold;
  }
`
export const CuponsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;

  thead {
    background-color: #B1DBF0;
    
    th {
      padding: 8px 24px;  
      text-align: left;
      font-weight: bold;
    }
    
  }

  tbody {
    tr {
      border-bottom: 1px solid #eee;
      position: relative;
      background-color: white;

      &:hover {
        font-weight: bold;
        background-color: #DDD;
      }
    }
    
    td {
      padding: 8px 24px;  
    }
}
`;


export const BtnVerMais = styled(Button)`
  display: flex;
  align-items: center;
  background: transparent;
  border: 2px solid ${theme.palette.brand.primary.key};
  cursor: pointer;
  background-color: none;
  padding: 10px 24px;
  border-radius: 32px;
  font-weight: 400;
  width: 100%; 

  @media (min-width: ${theme.breakpoints.values.md}px) {
    margin-bottom: 0;
    border: 2px solid ${theme.palette.brand.primary.key};
    width: auto;

    svg path {
      fill: white;
    }

  }

  span {
    color: ${theme.palette.brand.primary.key};
    display: flex;

    svg {
      margin-right: 8px;
    }

  }

  &:hover {
    border-color: ${theme.palette.neutral.primary.light};
    background-color: ${theme.palette.neutral.primary.light};;
    color: ${theme.palette.brand.primary.key};
    
    span {
      display: flex;
      color: ${theme.palette.brand.primary.key};

      svg {
        margin-right: 8px;

        circle {
          fill: ${theme.palette.brand.primary.key};
        }

        path {
          fill: ${theme.palette.brand.primary.key};
        }
      }
    }
  }
`;

export const ContainerBtnVerMais = styled.div `
  margin-top: 24px;
  display: flex;
  justify-content: center;
  width: 100%;

  a {
    color: ${theme.palette.brand.primary.key};
    text-decoration: none;
    display: flex;
    align-items: center;
    background: transparent;
    border: 2px solid ${theme.palette.brand.primary.key};
    cursor: pointer;
    background-color: none;
    padding: 10px 24px;
    border-radius: 32px;
    font-weight: 400;
    width: 100%; 
    text-align: center;
    justify-content: center;

    &:hover {
      border-color: ${theme.palette.neutral.primary.light};
      background-color: ${theme.palette.neutral.primary.light};;
      color: ${theme.palette.brand.primary.key};

    }
  }

  

  @media (min-width: ${theme.breakpoints.values.md}px) {
    a {
      width: auto;
    }
  }
`

export const EditarDadosContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 16px;

  h6 {
    line-height: 1;
  }
`

export const DadosContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

export const EditBtnContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  p {
    color: black;
    text-decoration: underline;
    font-size: 20px;
    font-weight: bold;
  }
`

export const Title = styled.div`
  font-size: 36px;
  font-weight: bold;
`